import { withQuery } from './lib/withQuery'

export const getStartFollowUrl = (username: string) => withQuery('author/follow', { username })

export const getDeleteFollowUrl = (username: string) => withQuery('author/follow', { username })

export const getAuthorFollowersUrl = (username: string) =>
    withQuery('social/followers', { username })

export const getAuthorFollowingUrl = (username: string) =>
    withQuery('social/following', { username })

export const getFeedUrl = () => 'feed'

export const getFollowCheckUrl = () => 'follow/check'

export const getFollowStatsUrl = () => 'follow/stats'
